<template>

    <h1>Benefícios e Parceiros</h1>

    <v-container class="pa-0 mx-0">
      <v-row class="mb-4">
        <v-col cols="12" lg="2">
          <v-text-field
            v-model="searchForm.name"
            id="name"
            label="Benefício/Parceiro" 
            variant="outlined"
            bg-color="white"
            color="#03af9a"
            hide-details
            clearable
            clear-icon="mdi-close"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="2">
          <v-select
            v-model="searchForm.state"
            :items="states"
            id="state"
            label="Estado" 
            variant="outlined"
            bg-color="white"
            color="#03af9a"
            hide-details
          >
          </v-select>
        </v-col>
        <v-col cols="12" lg="1">
          <v-btn
            class="bg-amber-darken-1 w-100 mt-3"
            rounded
            variant="flat"
            @click="fetchPartners"
          >
            BUSCAR
          </v-btn>
        </v-col>
        <v-col cols="12" lg="7">

          <h3 class="title">Categorias</h3>

          <label
            class="btn-category"
            v-for="(category, index) of categories"
            :key="index"
          >
            <input
              @click="fetchPartners()"
              type="checkbox"
              v-model="searchForm.categories"
              :value="category.id"
            >
            {{ category.title }}
          </label>
        
        </v-col>
      </v-row>
    </v-container>

    <v-container class="pa-0 mx-0 mt-5">

      <v-row v-if="loadingPartners" class="text-center justify-center">
        <v-progress-circular indeterminate color="black" class="align-self-center my-4"></v-progress-circular>
      </v-row>

      <v-row v-else-if="groupedPartners.length > 0" class="text-center">
        <SliderCategoriaParceiros
          v-for="(category, index) of groupedPartners" :key="index"
          :title="category.title"
          :partners="category.partners"
        />
      </v-row>

      <v-row v-else class="justify-center">
        <p class="text-center my-4">Não há parceiros para as opções selecionadas</p>
      </v-row>


    </v-container>

</template>

<script setup>
  import { inject, onMounted, ref } from 'vue';
  import SliderCategoriaParceiros from '@/components/SliderCategoriaParceiros.vue'
  import Button from '@/components/Button.vue'
  import { useDisplay } from 'vuetify';

  const axios = inject('axios');
  const backendUrl = inject('backendUrl');
  const csrfUrl = inject('csrfUrl');
  const states = ref([
    { value: '', title: 'Todos estados' },
    { value: 'AC', title: 'Acre' },
    { value: 'AL', title: 'Alagoas' },
    { value: 'AP', title: 'Amapá' },
    { value: 'AM', title: 'Amazonas' },
    { value: 'BA', title: 'Bahia' },
    { value: 'CE', title: 'Ceará' },
    { value: 'DF', title: 'Distrito Federal' },
    { value: 'ES', title: 'Espirito Santo' },
    { value: 'GO', title: 'Goiás' },
    { value: 'MA', title: 'Maranhão' },
    { value: 'MS', title: 'Mato Grosso do Sul' },
    { value: 'MT', title: 'Mato Grosso' },
    { value: 'MG', title: 'Minas Gerais' },
    { value: 'PA', title: 'Pará' },
    { value: 'PB', title: 'Paraíba' },
    { value: 'PR', title: 'Paraná' },
    { value: 'PE', title: 'Pernambuco' },
    { value: 'PI', title: 'Piauí' },
    { value: 'RJ', title: 'Rio de Janeiro' },
    { value: 'RN', title: 'Rio Grande do Norte' },
    { value: 'RS', title: 'Rio Grande do Sul' },
    { value: 'RO', title: 'Rondônia' },
    { value: 'RR', title: 'Roraima' },
    { value: 'SC', title: 'Santa Catarina' },
    { value: 'SP', title: 'São Paulo' },
    { value: 'SE', title: 'Sergipe' },
    { value: 'TO', title: 'Tocantins' }
  ]);
  const categories = ref([]);
  const groupedPartners = ref([]);
  const loadingPartners = ref(true);

  //filtros
  let searchForm = ref({
    name: '',
    state: '',
    categories: [],
  });

  //busca categorias
  const getCategories = () => {
    axios.get(backendUrl + '/get-partner-categories')
    .then((response) => {
      categories.value = response.data;
    });
  }


  //busca parceiros
  const fetchPartners = async () => {
    loadingPartners.value = true;
    await axios.get(csrfUrl); 
    axios.post(
      backendUrl + '/partners',
      {filters: searchForm.value},
    ).then((response) => {
      loadingPartners.value = false;
      //parceiros
      groupedPartners.value = response.data;
    });
  }

  onMounted(() => {
    getCategories();
    fetchPartners();
    window.scrollTo(0,0);
  })
</script>

<style scoped lang="scss">


.title {
    font-size: 22px;
    text-align: left;
    margin-left: 10px;
    margin-bottom: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.btn-category {
	display: inline-block;
  background-color: none;
  color: $verde-opus;
  margin: 3px;
  padding: 8px 16px;
  border: 2px solid $verde-opus;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
}
.btn-category input[type=checkbox] {
	appearance: none;
	-webkit-appearance: none;
}
.btn-category:has(input[type=checkbox]:checked) {
	background: $verde-opus;
	color: #fff;
}
</style>